var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: _vm.enableScroll,
          expression: "enableScroll",
        },
      ],
      ref: "element",
      staticClass:
        "color-element container px-0 d-flex flex-column flex-lg-row",
      class: _vm.sideInfoDocked ? "side-info-docked" : "",
      on: {
        touchmove: _vm.touchmove,
        wheel: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            )
              return null
            return _vm.enableScroll.apply(null, arguments)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown",
              ])
            )
              return null
            return _vm.enableScroll.apply(null, arguments)
          },
        ],
      },
    },
    [
      _c("div", { staticClass: "w-100" }, [
        _c(
          "div",
          {
            staticClass: "w-100 colorworld__outerCanvas position-relative",
            attrs: { id: "colorcircle__outerCanvas" },
          },
          [
            _c("canvas", {
              staticClass: "position-absolute top-0 left-0",
              attrs: { id: "colorcircle" },
              on: { mousemove: _vm.mousemove, click: _vm.clickIt },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "colorworld__outerCanvas__innerInfo position-absolute w-25 h-25 d-flex flex-column align-items-center justify-content-center",
              },
              [
                null != _vm.colorActive
                  ? _c("p", {
                      domProps: {
                        textContent: _vm._s(_vm.t("colorworld.color_number")),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                null != _vm.colorActive
                  ? _c("h3", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.colorLists[_vm.colorListLoaded][_vm.colorActive]
                            .code
                        ),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                null != _vm.colorListLoaded
                  ? _c("p", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.fabricTypes[_vm.colorListLoaded].fabricClass
                          ),
                        },
                      }),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "color-search-container position-absolute" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchNumber,
                      expression: "searchNumber",
                    },
                  ],
                  staticClass: "color-search-input",
                  attrs: {
                    type: "tel",
                    maxlength: "3",
                    pattern: "[0-9]{3}",
                    placeholder: _vm.t("colorworld.color_search"),
                  },
                  domProps: { value: _vm.searchNumber },
                  on: {
                    wheel: function ($event) {
                      return $event.target.blur()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.searchNumber = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("Transition", { attrs: { name: "fade" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.searchError,
                          expression: "searchError",
                        },
                      ],
                      staticClass: "error",
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.t("colorworld.color_search_error")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "colorworld__sideInfo pt-2 pt-xl-0 pb-3 pb-xl-0 px-3 w-100 relative",
        },
        [
          null != _vm.colorActive
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "colorworld__sideInfo__imageContainer mt-5 mt-xl-0 position-relative",
                  },
                  [
                    _c("img", {
                      staticClass: "w-100 h-100 top-0 left-0 position-absolute",
                      attrs: {
                        src: _vm.colorLists[_vm.colorListLoaded][
                          _vm.colorActive
                        ].img,
                        loading: "lazy",
                      },
                    }),
                    _vm._v(" "),
                    97 <
                    _vm.colorLists[_vm.colorListLoaded][_vm.colorActive]
                      .uv_protection
                      ? _c("img", {
                          staticClass: "uvprotection position-absolute",
                          attrs: {
                            src: "/img/uvprotection.png",
                            loading: "lazy",
                          },
                        })
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "colorworld__sideInfo__text bg-light-grey" },
                  [
                    _c("p", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.colorLists[_vm.colorListLoaded][_vm.colorActive]
                            .code
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("h3", {
                      staticClass: "pt-1",
                      domProps: {
                        textContent: _vm._s(
                          _vm.colorLists[_vm.colorListLoaded][_vm.colorActive]
                            .title
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "pt-3 pt-xl-4",
                      domProps: {
                        textContent: _vm._s(
                          _vm.colorLists[_vm.colorListLoaded][_vm.colorActive]
                            .extra_description
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _vm.colorLists[_vm.colorListLoaded][_vm.colorActive]
                      .description
                      ? _c("p", { staticClass: "pt-3 pt-xl-4" }, [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.colorLists[_vm.colorListLoaded][
                                  _vm.colorActive
                                ].description
                              ),
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "colorworld__sideInfo__text__attributes row pt-5 mx-0",
                      },
                      [
                        _vm.colorLists[_vm.colorListLoaded][_vm.colorActive]
                          .uv_protection
                          ? _c(
                              "div",
                              { staticClass: "col-12 col-xl-6 d-flex px-0" },
                              [
                                _c("p", { staticClass: "pr-2 pb-1" }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.t("colorworld.uv_protection")
                                      ) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.colorLists[_vm.colorListLoaded][
                                          _vm.colorActive
                                        ].uv_protection
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("%")]),
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "expandIcon",
                                  on: {
                                    click: function ($event) {
                                      _vm.openPopup()
                                      _vm.fabricClassTabs = 0
                                    },
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.colorLists[_vm.colorListLoaded][_vm.colorActive]
                          .light_protection
                          ? _c(
                              "div",
                              { staticClass: "col-12 col-xl-6 d-flex px-0" },
                              [
                                _c("p", { staticClass: "pr-2 pb-1" }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.t("colorworld.color_realness")
                                      ) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.colorLists[_vm.colorListLoaded][
                                          _vm.colorActive
                                        ].light_protection
                                      ),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "expandIcon",
                                  on: {
                                    click: function ($event) {
                                      _vm.openPopup()
                                      _vm.fabricClassTabs = 0
                                    },
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.colorLists[_vm.colorListLoaded][_vm.colorActive]
                          .surface_weight
                          ? _c(
                              "div",
                              { staticClass: "col-12 col-xl-6 d-flex px-0" },
                              [
                                _c("p", { staticClass: "pr-2 pb-1" }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.t("colorworld.surface_weight")
                                      ) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.colorLists[_vm.colorListLoaded][
                                          _vm.colorActive
                                        ].surface_weight
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("g/m2")]),
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "expandIcon",
                                  on: {
                                    click: function ($event) {
                                      _vm.openPopup()
                                      _vm.fabricClassTabs = 0
                                    },
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.colorLists[_vm.colorListLoaded][_vm.colorActive]
                          .water_protection
                          ? _c(
                              "div",
                              { staticClass: "col-12 col-xl-6 d-flex px-0" },
                              [
                                _c("p", { staticClass: "pr-2 pb-1" }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.t("colorworld.water_resistance")
                                      ) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.colorLists[_vm.colorListLoaded][
                                          _vm.colorActive
                                        ].water_protection
                                      ),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "expandIcon",
                                  on: {
                                    click: function ($event) {
                                      _vm.openPopup()
                                      _vm.fabricClassTabs = 0
                                    },
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.colorLists[_vm.colorListLoaded][_vm.colorActive]
                          .fabricClass
                          ? _c(
                              "div",
                              { staticClass: "col-12 col-xl-6 d-flex px-0" },
                              [
                                _c("p", { staticClass: "pr-2 pb-1" }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.t("colorworld.fabric_classes")
                                      ) + ":"
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "fabricClassIcon",
                                  class:
                                    "fabricClass" +
                                    _vm.colorLists[_vm.colorListLoaded][
                                      _vm.colorActive
                                    ].fabricClass,
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "colorworld__sideInfo__text bg-light-grey mt-1 colorworld__sideInfo__text__lower d-flex justify-content-between align-items-center",
                    on: {
                      click: function ($event) {
                        _vm.openPopup()
                        _vm.fabricClassTabs = 1
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("div", { staticClass: "layerIcon" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "pl-4" }, [
                        _c("h4", [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("colorworld.glatz_covers")
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.t("colorworld.get_more_info")
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "5",
                          height: "6.774",
                          viewBox: "0 0 5 6.774",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            id: "play-button",
                            d: "M10.43,3.254,5.753.028A.161.161,0,0,0,5.5.161V6.613a.161.161,0,0,0,.253.133L10.43,3.52a.161.161,0,0,0,0-.265Z",
                            transform: "translate(-5.5)",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            : [
                _c("h3", {
                  domProps: {
                    textContent: _vm._s(_vm.t("colorworld.no_fabric")),
                  },
                }),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "infosPopup position-fixed top-0 left-0 w-100 h-100 overflow-auto",
          class: [_vm.fabricClassInfosPopupOpen ? "show" : ""],
          on: {
            click: function ($event) {
              return _vm.closeInfosPopup($event)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "w-100 min-vh-100 d-flex justify-content-center align-items-center",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "infosPopup__inner fabricClass container-small bg-white w-100 position-relative",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "closing d-block bg-light-grey",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "aria-label": "Close",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.closePopup()
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "14.811",
                            height: "14.811",
                            viewBox: "0 0 14.811 14.811",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              id: "close.2",
                              d: "M14.811.873,13.938,0,7.405,6.533.873,0,0,.873,6.533,7.405,0,13.938l.873.873L7.405,8.278l6.533,6.533.873-.873L8.278,7.405Z",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.t("colorworld.context_fabric_class")
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "fabricClass__tabContainer" }, [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex justify-content-center pb-5 mb-2",
                      },
                      [
                        _c("div", { staticClass: "tabSwitcher d-flex" }, [
                          _c("button", {
                            class: [_vm.fabricClassTabs == 0 ? "active" : ""],
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("colorworld.properties")
                              ),
                            },
                            on: {
                              click: function ($event) {
                                _vm.fabricClassTabs = 0
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("button", {
                            class: [_vm.fabricClassTabs == 1 ? "active" : ""],
                            domProps: {
                              textContent: _vm._s(_vm.t("colorworld.info")),
                            },
                            on: {
                              click: function ($event) {
                                _vm.fabricClassTabs = 1
                              },
                            },
                          }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "fabricClass__tabs position-relative" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "fabricClass__tabs__item overflow-auto",
                            class: [_vm.fabricClassTabs == 0 ? "active" : ""],
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "fabricClass__table row" },
                              [
                                _c("div", { staticClass: "col-3 px-0" }, [
                                  _c("div", {
                                    staticClass:
                                      "d-flex align-items-center bg-white",
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "d-flex align-items-center bg-white",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center pl-4",
                                    },
                                    [
                                      _c("p", [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.t("colorworld.material")
                                            ),
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center pl-4",
                                    },
                                    [
                                      _c("p", [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.t("colorworld.surface_weight")
                                            ),
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center pl-4",
                                    },
                                    [
                                      _c("p", [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.t(
                                                "colorworld.staininghazards"
                                              )
                                            ),
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center pl-4",
                                    },
                                    [
                                      _c("p", [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.t("colorworld.color_realness")
                                            ),
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center pl-4",
                                    },
                                    [
                                      _c("p", [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.t(
                                                "colorworld.waterresistance"
                                              )
                                            ),
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center pl-4",
                                    },
                                    [
                                      _c("p", [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.t("colorworld.uv_protection")
                                            ),
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-3 px-0" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-end justify-content-center bg-white",
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "recomendation" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.t("colorworld.recomend"))
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center bg-beige",
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "w-100 d-flex justify-content-center align-items-center",
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "text-center d-block pr-3",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.t("colorworld.fabric_class")
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass:
                                              "d-block fabricClassIcon fabricClassIcon--big fabricClass62",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center bg-beige",
                                    },
                                    [
                                      _c("p", {
                                        staticClass: "text-center w-100",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.t("colorworld.polyester-set5")
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center bg-beige",
                                    },
                                    [
                                      _c("p", {
                                        staticClass: "text-center w-100",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.t(
                                              "colorworld.dyed_filament-set5"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center bg-beige",
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "text-center w-100" },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.t(
                                                  "colorworld.level-set5-title"
                                                )
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.t(
                                                  "colorworld.level-set5-subtitle"
                                                )
                                              ) +
                                              "\n                                            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _vm._m(2),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-3 px-0" }, [
                                  _c("div", {
                                    staticClass:
                                      "d-flex align-items-center bg-white",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "w-100 d-flex justify-content-center align-items-center",
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "text-center d-block pr-3",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.t("colorworld.fabric_class")
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass:
                                              "d-block fabricClassIcon fabricClassIcon--big fabricClass58",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      _c("p", {
                                        staticClass: "text-center w-100",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.t("colorworld.polyester-set4")
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      _c("p", {
                                        staticClass: "text-center w-100",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.t(
                                              "colorworld.dyed_filament-set4"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "text-center w-100" },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.t(
                                                  "colorworld.level-set4-title"
                                                )
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.t(
                                                  "colorworld.level-set4-subtitle"
                                                )
                                              ) +
                                              "\n                                            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._m(4),
                                  _vm._v(" "),
                                  _vm._m(5),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-3 px-0" }, [
                                  _c("div", {
                                    staticClass:
                                      "d-flex align-items-center bg-white",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "w-100 d-flex justify-content-center align-items-center",
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "text-center d-block pr-3",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.t("colorworld.fabric_class")
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass:
                                              "d-block fabricClassIcon fabricClassIcon--big fabricClass61",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      _c("p", {
                                        staticClass: "text-center w-100",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.t("colorworld.polyester-set2")
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._m(6),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      _c("p", {
                                        staticClass: "text-center w-100",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.t(
                                              "colorworld.dyed_filament-set2"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "text-center w-100" },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.t(
                                                  "colorworld.level-set2-title"
                                                )
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.t(
                                                  "colorworld.level-set2-subtitle"
                                                )
                                              ) +
                                              "\n                                            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._m(7),
                                  _vm._v(" "),
                                  _vm._m(8),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center mt-3" },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "mr-1",
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "13.829",
                                      height: "13.829",
                                      viewBox: "0 0 13.829 13.829",
                                    },
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          id: "Border",
                                          fill: "#f8f8f8",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M 6.914713859558105 13.57942390441895 C 3.239783763885498 13.57942390441895 0.2500038743019104 10.58964347839355 0.2500038743019104 6.914713859558105 C 0.2500038743019104 3.239783763885498 3.239783763885498 0.2500038743019104 6.914713859558105 0.2500038743019104 C 10.58964347839355 0.2500038743019104 13.57942390441895 3.239783763885498 13.57942390441895 6.914713859558105 C 13.57942390441895 10.58964347839355 10.58964347839355 13.57942390441895 6.914713859558105 13.57942390441895 Z",
                                            stroke: "none",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            d: "M 6.914713859558105 0.5000038146972656 C 3.377634048461914 0.5000038146972656 0.5000038146972656 3.377634048461914 0.5000038146972656 6.914713859558105 C 0.5000038146972656 10.4517936706543 3.377634048461914 13.32942390441895 6.914713859558105 13.32942390441895 C 10.4517936706543 13.32942390441895 13.32942390441895 10.4517936706543 13.32942390441895 6.914713859558105 C 13.32942390441895 3.377634048461914 10.4517936706543 0.5000038146972656 6.914713859558105 0.5000038146972656 M 6.914713859558105 3.814697265625e-06 C 10.73360443115234 3.814697265625e-06 13.82942390441895 3.095824241638184 13.82942390441895 6.914713859558105 C 13.82942390441895 10.73360443115234 10.73360443115234 13.82942390441895 6.914713859558105 13.82942390441895 C 3.095824241638184 13.82942390441895 3.814697265625e-06 10.73360443115234 3.814697265625e-06 6.914713859558105 C 3.814697265625e-06 3.095824241638184 3.095824241638184 3.814697265625e-06 6.914713859558105 3.814697265625e-06 Z",
                                            stroke: "none",
                                            fill: "#e60014",
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        id: "Icon",
                                        d: "M33.916,5.78l-.091.37q-.407.161-.65.245a1.715,1.715,0,0,1-.564.084,1.125,1.125,0,0,1-.767-.241.779.779,0,0,1-.274-.611,2.161,2.161,0,0,1,.02-.294q.021-.15.066-.339L32,3.793q.045-.173.076-.327a1.422,1.422,0,0,0,.031-.282.435.435,0,0,0-.095-.321.537.537,0,0,0-.363-.091.951.951,0,0,0-.27.041c-.092.027-.171.054-.238.078l.091-.37q.334-.136.638-.232a1.909,1.909,0,0,1,.577-.1,1.1,1.1,0,0,1,.755.237.786.786,0,0,1,.265.615c0,.052-.006.144-.018.276a1.843,1.843,0,0,1-.068.362l-.338,1.2a3.18,3.18,0,0,0-.074.33,1.7,1.7,0,0,0-.033.28.4.4,0,0,0,.106.325.6.6,0,0,0,.37.086,1.068,1.068,0,0,0,.28-.043A1.563,1.563,0,0,0,33.916,5.78ZM34,.757a.7.7,0,0,1-.236.533.8.8,0,0,1-.569.22.814.814,0,0,1-.572-.22.7.7,0,0,1-.239-.533.706.706,0,0,1,.239-.535.845.845,0,0,1,1.142,0A.707.707,0,0,1,34,.757Z",
                                        transform: "translate(-25.897 3.436)",
                                        fill: "#e60014",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("h4", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.t("colorworld.recomendation")
                                    ),
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fabricClass__tabs__item",
                            class: [1 == _vm.fabricClassTabs ? "active" : ""],
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "fabricClass__accordion" },
                              _vm._l(
                                _vm.fabricClassAccordionItems,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    { key: index, attrs: { item: item } },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "fabricClass__accordion__item fabricClass__accordion__item--accordion d-flex justify-content-between align-items-center",
                                          class: [item.active ? "active" : ""],
                                          on: {
                                            click: function ($event) {
                                              return _vm.setAccordionActive(
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("p", {
                                            staticClass: "pr-1 title",
                                            domProps: {
                                              textContent: _vm._s(item.title),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "svg",
                                            {
                                              staticClass: "plus",
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                viewBox: "0 0 16 16",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M15.869,24.5V17.131H8.5V15.869h7.369V8.5h1.263v7.369H24.5v1.263H17.131V24.5Z",
                                                  transform:
                                                    "translate(-8.5 -8.5)",
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "svg",
                                            {
                                              staticClass: "minus",
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                viewBox: "0 0 16 16",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "m 8.5,17.131 v -1.262 h 16 v 1.263 c -16,-0.001 0,0 -16,-0.001 z",
                                                  transform:
                                                    "translate(-8.5,-8.5)",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "fabricClass__accordion__panel",
                                          class: [item.active ? "active" : ""],
                                        },
                                        [
                                          _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(item.content),
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mb-1" }),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "colorworld__sideInfo__paginationForMobile d-flex d-lg-none w-100",
          class: _vm.sideInfoDocked ? "" : "position-fixed",
        },
        [
          _c("div", { staticClass: "bg-light-grey w-100 d-flex d-lg-none" }, [
            _c(
              "div",
              { staticClass: "colorworld__sideInfo__paginationForMobile__img" },
              [
                _c("img", {
                  staticClass: "w-100 h-100",
                  attrs: {
                    src: _vm.colorLists[_vm.colorListLoaded][_vm.colorActive]
                      .img,
                    loading: "lazy",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "colorworld__sideInfo__paginationForMobile__info w-100 d-flex align-items-center justify-content-between",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "colorworld__sideInfo__paginationForMobile__info__left",
                  },
                  [
                    _c("p", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.colorLists[_vm.colorListLoaded][_vm.colorActive]
                            .code
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("h4", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.colorLists[_vm.colorListLoaded][_vm.colorActive]
                            .title
                        ),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "colorworld__sideInfo__paginationForMobile__info__right d-flex",
                  },
                  [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.clickItMobile($event, -1)
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticStyle: {
                              "enable-background": "new 0 0 407.436 407.436",
                              transform: "scale(-1, 1)",
                            },
                            attrs: {
                              width: "15px",
                              height: "14.5px",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                              x: "0px",
                              y: "0px",
                              viewBox: "0 0 407.436 407.436",
                              "xml:space": "preserve",
                            },
                          },
                          [
                            _c("polygon", {
                              attrs: {
                                points:
                                  "112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 ",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.clickItMobile($event, +1)
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "ml-3",
                            staticStyle: {
                              "enable-background": "new 0 0 407.436 407.436",
                            },
                            attrs: {
                              width: "15px",
                              height: "14.5px",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                              x: "0px",
                              y: "0px",
                              viewBox: "0 0 407.436 407.436",
                              "xml:space": "preserve",
                            },
                          },
                          [
                            _c("polygon", {
                              attrs: {
                                points:
                                  "112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 ",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center bg-beige" }, [
      _c("p", { staticClass: "text-center w-100" }, [_vm._v("300g/m2")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center bg-beige" }, [
      _c("p", { staticClass: "text-center w-100" }, [_vm._v("> 350 mm")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center bg-beige" }, [
      _c("p", { staticClass: "text-center w-100" }, [_vm._v("> 98 %")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("p", { staticClass: "text-center w-100" }, [_vm._v("250g/m2")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("p", { staticClass: "text-center w-100" }, [_vm._v("> 150 mm")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("p", { staticClass: "text-center w-100" }, [_vm._v("> 98 %")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("p", { staticClass: "text-center w-100" }, [_vm._v("220g/m2")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("p", { staticClass: "text-center w-100" }, [_vm._v("> 100 mm")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("p", { staticClass: "text-center w-100" }, [_vm._v("> 98 %")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }